import Cookies from "js-cookie";
import { useLocation } from "@reach/router";
// import * as amplitude from "@amplitude/analytics-browser";

export const useCookiesHook = () => {
  const location = useLocation();
  const { hostname } = location;
  const cookiesCookieName = "cookiesConsent";
  const tagmanagerCookieName = "googleTagManager";
  // const gaProperty = "UA-137280124-3";

  const getCookie = function (name) {
    return Cookies.get(name) && JSON.parse(Cookies.get(name));
  };

  const removeCookie = function (name) {
    Cookies.remove(name, { domain: hostname });
  };

  const removeAnalyticsCookies = function () {
    Object.keys(Cookies.get()).forEach((cookieName) => {
      if (/^_.*/.test(cookieName)) removeCookie(cookieName);
    });
  };

  const manageTagManager = function (enable, reload = true) {
    // loadGoogleAnalytics(); // REMOVE BEFORE JAN 2024
    // return; // REMOVE BEFORE JAN 2024

    writeCookie(tagmanagerCookieName, enable);
    if (!enable) removeAnalyticsCookies();
    if (reload) window.location.reload();
  };

  const buildConsentCookie = (personalization, analytics) => ({
    technical: true,
    personalization,
    analytics,
  });

  const writeCookie = (name, value) => {
    if (!name || value === undefined || value === null) return null;
    return Cookies.set(name, JSON.stringify(value), {
      domain: hostname,
      expires: 365,
    });
  };

  const acceptSomeCookies = (
    isPersonalizationCookieEnabled = false,
    isAnalyticsCookieEnabled = false,
  ) => {
    manageTagManager(isAnalyticsCookieEnabled, false);
    writeCookie(
      cookiesCookieName,
      buildConsentCookie(
        isPersonalizationCookieEnabled,
        isAnalyticsCookieEnabled,
      ),
    );
    window.location.reload();
  };

  const acceptAllCookies = () => {
    manageTagManager(true);
    // amplitude.track("All Cookies Accepted");
    writeCookie(cookiesCookieName, buildConsentCookie(true, true));
  };

  const rejectOptionalCookies = () => {
    manageTagManager(false);
    // amplitude.track("Cookies Rejected");
    writeCookie(cookiesCookieName, buildConsentCookie(false, false));
  };

  // const gtag = (...args) => window.dataLayer?.push(args);

  // const loadGoogleAnalytics = () => {
  //   // const script = window.document.createElement("script")
  //   // script.src = `https://www.googletagmanager.com/gtag/js?id=${gaProperty}`
  //   // script.src = "https://www.googletagmanager.com/ns.html?id=GTM-WKX9RG4"
  //   // script.async = true
  //   // window.document.body.appendChild(script)
  //   window.dataLayer = window.dataLayer || [];
  //   gtag("js", new Date());
  //   gtag("config", gaProperty);
  // };

  return {
    cookies: getCookie(cookiesCookieName),
    acceptSomeCookies,
    acceptAllCookies,
    rejectOptionalCookies,
  };
};
